/**
 * Pulni MATNGA aylantirish.
 *
 * Nega kontraktda, `@aps/ui` da emas: pul faqat ekranda emas, botda
 * ham ko'rsatiladi (`@aps/bot` — Node, React emas). UI paketini botga
 * tortib kelish JSX ni Node ilovasiga olib kirardi, takrorlash esa
 * aynan shu qoida to'sadigan holatga olib kelardi — bir joyda
 * "385 000", boshqasida "385,000" (avtopart-money skill).
 *
 * `@aps/ui` bularni QAYTA EKSPORT qiladi, shuning uchun ekranlardagi
 * importlar o'zgarmaydi.
 */
/** Bir so'mdagi tiyin. */
const TIYIN_PER_SUM = 100n;
/** Uzluksiz probel — ming ajratgich sifatida (docs/03-UI-UX.md). */
const THIN_SPACE = ' ';
/**
 * Tiyinni ko'rsatiladigan summaga aylantiradi.
 *
 * Kirish — kontraktdagi `Money` (string, tiyin). Tiyin KO'RSATILMAYDI:
 * narxlar butun so'mda, va "385 000,00" mijozni chalg'itadi.
 */
export function formatMoney(tiyin, locale) {
    const parsed = /^-?\d+$/.test(tiyin) ? BigInt(tiyin) : null;
    if (parsed === null)
        return '';
    const negative = parsed < 0n;
    const sums = (negative ? -parsed : parsed) / TIYIN_PER_SUM;
    const grouped = sums.toString().replace(/\B(?=(\d{3})+(?!\d))/g, THIN_SPACE);
    const unit = locale === 'RU' ? 'сум' : "so'm";
    return `${negative ? '−' : ''}${grouped}${THIN_SPACE}${unit}`;
}
/** Faqat raqam qismi — narx yorlig'i birlikni alohida ko'rsatganda. */
export function formatMoneyValue(tiyin) {
    const parsed = /^-?\d+$/.test(tiyin) ? BigInt(tiyin) : null;
    if (parsed === null)
        return '';
    const negative = parsed < 0n;
    const sums = (negative ? -parsed : parsed) / TIYIN_PER_SUM;
    return `${negative ? '−' : ''}${sums.toString().replace(/\B(?=(\d{3})+(?!\d))/g, THIN_SPACE)}`;
}
export function moneyUnit(locale) {
    return locale === 'RU' ? 'сум' : "so'm";
}
/**
 * Odam kiritgan summani tiyinga aylantiradi — `formatMoney` ning teskarisi.
 *
 * Admin panelda operator SO'M yozadi ("385 000"), API esa TIYIN kutadi
 * ("38500000"). Bu almashtirish har formada qaytadan yozilsa, bir joyda
 * `Number(...) * 100` paydo bo'ladi va katta summada aniqlik yo'qoladi.
 * Shuning uchun konvertatsiya faqat shu yerda va faqat BigInt bilan.
 *
 * Qabul qilinadi: raqamlar, ming ajratgich sifatida probel (oddiy, uzluksiz,
 * ingichka), va ikkitagacha kasr xonasi (`,` yoki `.`) — tiyin.
 * Qolgan hamma narsa — `null`. Manfiy summa ham `null`: pulni "minus"
 * qilib yozish emas, qaytarish amali bilan qaytariladi.
 *
 * @returns tiyindagi butun son, string ko'rinishida; noto'g'ri kirishda `null`
 */
export function parseSumInput(input) {
    // `\s` Unicode rejimida barcha probellarni qamraydi — oddiy (U+0020),
    // uzluksiz (U+00A0), ingichka (U+2009), tor uzluksiz (U+202F). Nusxa
    // ko'chirib qo'yilgan "385 000" ham shu tufayli ishlaydi.
    const cleaned = input.replace(/\s/gu, '').replace(',', '.');
    if (cleaned === '')
        return null;
    const match = /^(\d+)(?:\.(\d{1,2}))?$/u.exec(cleaned);
    if (match === null)
        return null;
    const sums = BigInt(match[1] ?? '0');
    // "5.5" — 50 tiyin, "5.05" — 5 tiyin. Xonani to'ldirmasdan qo'shib
    // yuborish 5.5 ni 5 tiyin qilib qo'yardi.
    const fraction = (match[2] ?? '').padEnd(2, '0');
    return (sums * TIYIN_PER_SUM + BigInt(fraction)).toString();
}
/**
 * Tiyinni forma maydoniga yoziladigan matnga aylantiradi.
 *
 * `formatMoney` ishlatilmaydi: u birlik ("so'm") va uzluksiz probel
 * qo'shadi, ular esa maydondan qayta o'qilganda chalkashtiradi. Bu
 * yerda faqat toza raqam — `parseSumInput` uni aynan qaytaradi.
 */
export function formatSumInput(tiyin) {
    const parsed = /^\d+$/.test(tiyin) ? BigInt(tiyin) : null;
    if (parsed === null)
        return '';
    const sums = parsed / TIYIN_PER_SUM;
    const rest = parsed % TIYIN_PER_SUM;
    return rest === 0n ? sums.toString() : `${sums.toString()}.${rest.toString().padStart(2, '0')}`;
}
//# sourceMappingURL=money-format.js.map